import * as React from 'react'
import { TeamNameLinkConnected } from './TeamNameLinkConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TeamNameLinkExamples = () => {
  return (
    <div className="TeamNameLinkExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamNameLinkConnected />
      </Provider>
    </div>
  )
}
